<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="catalog"
                dense
                item-key="id"
                :show-select="false"
                :options.sync="options"
                :page.sync="page"
                :server-items-length="countItems"
                :loading="loading"
                class="elevation-1"
                :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-options': [5, 10, 15, 30, 50, 100],
                          itemsPerPageText: 'Товаров на странице ',
                          showCurrentPage: false
                        }"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Товары</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                    v-model="article"
                                    label="Арт."
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                    v-model="name"
                                    label="Название"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-btn @click="getDataFromApi">
                                <span class="text-none">
                                    <v-icon>search</v-icon>Поиск
                                </span>
                            </v-btn>
                        </v-col>
                        <v-col cols="2">
                            <v-btn @click="createProduct">
                                <span class="text-none">
                                    <v-icon>create</v-icon>Создать
                                </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>

              <v-dialog v-model="dialog" max-width="900px">
                <v-card>
                  <!--<v-card-title>
                      <span class="headline">Редактирование</span>
                  </v-card-title>-->
                  <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Редактировать </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text @click="saveProduct">
                        <v-icon>save</v-icon>
                        {{productModel.id === null ? 'Создать' : 'Сохранить'}}
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text class="content">
                    <v-container>
                      <v-form ref="form" v-model="valid">
                      <v-row>
                        <v-col cols="6" sm="12" md="6" class="py-0">
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.title"
                                          label="Название"
                                          required
                                          :rules="[rules.required, rules.maxLengthTitle]"
                            />
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.price"
                                          label="Цена"/>
                            <v-text-field v-model="productModel.oldPrice"
                                          label="Старая цена"/>
                          </v-col>
                          <v-col cols="12">
                            <v-select
                                label="Точка"
                                :items="deliveries"
                                item-text="title"
                                item-value="id"
                                v-model="productModel.deliveriesForm"
                                hide-details
                                multiple
                                chips
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-select
                                label="Категория"
                                :items="productCategories"
                                item-text="title"
                                item-value="id"
                                v-model="productModel.categoryId"
                                hide-details
                                chips
                            />
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-select
                                v-model="productModel.status"
                                label="Статус"
                                :items="[ { value: 1, text: 'Активно'}, { value: 2, text: 'Неактивно' } ]"
                            />
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-textarea
                                v-model="productModel.description"
                                label="Описание"
                            />
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.offer_id"
                                          label="id продукта в соответствии с файлом"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.article"
                                          label="Артикул"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.weight" label="Вес"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.volume" label="Объем"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.diameter" label="Диаметр"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.size" label="Размеры"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.color" label="Цвет"/>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="py-0">
                            <v-text-field v-model="productModel.stockQuantity" label="Остаток"/>
                          </v-col>

                        </v-col>
                        <v-col cols="6" sm="12" md="6" class="py-0">
                          <v-row>

                            <v-col cols="10">

                              <v-file-input accept=".jpeg,.jpg,.png" label="Выберите изображение" v-model="files"></v-file-input>
                            </v-col>
                            <v-col cols="2">
                              <v-icon
                                  @click="deleteImage"
                              >delete</v-icon>
                            </v-col>
                          </v-row>
                          <v-img
                              :src="productModel.picture ? productModel.picture : ''"
                              max-width="400"
                              max-height="600"
                              class="text-right pa-2"
                              :alt="productModel.title"
                              v-show="productModel.picture"
                              :lazy-src="productModel.picture"
                          />
                        </v-col>
                      </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:item.stockQuantity="{ item }">
                <v-edit-dialog
                        :return-value.sync="stockQuantityModel.stockQuantity"
                        large
                        persistent
                        @open="edit(item)"
                        @save="save()"
                >
                    <span>{{item.stockQuantity}}</span>
                    <template v-slot:input>
                        <v-text-field
                                v-model="stockQuantityModel.stockQuantity"
                                type="number"
                        />
                    </template>
                </v-edit-dialog>
            </template>
<!--          <template v-slot:item.deliveriesForm="{ item }">
            <span
            >
              {{ getDeliveryTitle(item.deliveriesForm )}}
            </span>
          </template>-->
          <template v-slot:item.action="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="updateProduct(item)"
            >
              edit
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="deleteItem(item.id)"
            >
              delete
            </v-icon>
          </template>
        </v-data-table>
      <v-snackbar
          v-model="paramsSnackbar.show"
          bottom
          :color="paramsSnackbar.color"
          right
      >
        {{paramsSnackbar.text}}
        <v-btn
            dark
            text
            @click="paramsSnackbar.show = false"
        >
          Закрыть
        </v-btn>
      </v-snackbar>
      <dialog-confirmation ref="confirm" :dialogParams="dialogParams"/>
    </div>
</template>

<script>
import constConf from '../../../constconf'
import { mapGetters } from 'vuex'
import axios from 'axios'
import DialogConfirmation from "@components/dialogs/DialogConfirmation";
export default {
    name: 'CatalogTable',
  components: {
    DialogConfirmation,
  },
    data() {
        return {
            valid: false,
            catalog: [],
            categories: [],
            offers: [],
            page: 1,
            options: { itemsPerPage: 15 },
            headers: [
                {
                    text: 'Арт.',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Название с описанием',
                    align: 'left',
                    sortable: false,
                    value: 'shortDescription'
                },
                {
                    text: 'Адрес',
                    align: 'left',
                    sortable: false,
                    value: 'deliveriesForm'
                },
                {
                    text: 'Категория',
                    align: 'left',
                    sortable: false,
                    value: 'categoryName'
                },
                {
                    text: 'Цена',
                    align: 'left',
                    sortable: false,
                    value: 'price'
                },
                {
                    text: 'Остаток',
                    align: 'left',
                    sortable: false,
                    value: 'stockQuantity'
                },
              { text: ' ', sortable: false, value: 'action' }
            ],
            article: '',
            name: '',
            countItems: 0,
            lastPage: 1,
            loading: false,
            dialog: false,
            paramsSnackbar: {
              color: 'success',
              text: 'Успешно сохранено!',
              show: false
            },
            dialogParams: {},
            stockQuantityModel: {
                id: null,
                stockQuantity: null,
                botId: null
            },
            productModel: {
                id: null,
                categoryId: null,
                deliveriesForm: [],
                status: 1,
                offerId: null,
                article: null,
                title: '',
                description: '',
                weight: null,
                volume: null,
                diameter: null,
                size: null,
                color: null,
                price: 0,
                oldPrice: null,
                picture: null,
                stockQuantity: 0,
                createdAt: null,
                updatedAt: null
            },
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length < 29) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 3000) || 'Максимальная длина сообщения 3000 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.'
            },
            files: null
        }
    },
    computed: {
        ...mapGetters({
            bot: 'bots/getBotById',
            bots: 'bots/bots',
            products: 'products/products',
            deliveries: 'cards/deliveries',
            productModelDef: 'products/productModelDef',
            productCategories: 'products/productCategories'
        })
    },
    watch: {
        async bots() {
            this.getDataFromApi()
        },
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true
        },
        files() {
            if (this.files) {
             this.$store.dispatch('tools/uploadImage', {payload: this.files, botId: this.productModel.botId}).then(result => {
                if (result.ok) {
                  this.productModel.picture = result.file.preview_url
                  this.paramsSnackbar.color = 'success'
                  this.paramsSnackbar.text = 'Загрузка изображения завершена!'
                } else {
                  this.paramsSnackbar.color = 'error'
                  this.paramsSnackbar.text = 'Изображение не загружено!'
                }
              })
              this.paramsSnackbar.show = true
              this.files = null
            }
        }
    },
    methods: {
      deleteImage() {
        this.productModel.picture = null
      },
      getDeliveryTitle(id) {
        let index = this.deliveries.findIndex(item => item.id == id)
        if (index && index > 0) {
          return this.deliveries[index].title
        }
        return ''
      },
        searchItems() {

        },
        async getDataFromApi () {
            this.loading = true
            let pageAction = 'all'
            let lastId = 0
            if (this.catalog.length > 0) {
                switch (this.options.page) {
                case 1: // первая страница
                    pageAction = 'all'
                    lastId = 0
                    break
                case Math.trunc(this.countItems / this.options.itemsPerPage) +
                    (this.countItems % this.options.itemsPerPage > 0 ? 1 : 0): // последняя страница
                    pageAction = 'last'
                    break
                default:
                    if (this.lastPage - this.options.page > 0) { // предыдущая страница
                        pageAction = 'previous'
                        lastId = this.catalog[0].id
                    } else { // следующая страница
                        pageAction = 'next'
                        lastId = this.catalog[this.catalog.length - 1].id
                    }
                }
            }
            let options = Object.assign(
                {
                    pageAction: pageAction,
                    lastId: lastId,
                    article: this.article,
                    name: this.name
                },
                this.options)
            delete options.mustSort
            delete options.multiSort
            delete options.groupBy
            delete options.groupDesc
            await axios.post(constConf.baseURLApi + '/shop/catalog/get-catalog/' + this.$route.params['pathMatch'], options)
                .then(response => {
                    this.lastPage = this.options.page
                    this.catalog = response.data.response.data
                    this.countItems = response.data.response.count
                    this.loading = false
                    return response.data
                })
        },
        edit(item) {
            this.stockQuantityModel.id = +item.id
            this.stockQuantityModel.stockQuantity = item.stockQuantity
            this.stockQuantityModel.botId = this.$route.params['pathMatch']
        },
        save() {

            /* let bot = Object.assign({}, this.bots.find(bot => bot.id === item.id))
                bot[this.field] = this.value */
            this.$store.dispatch('cards/catalogStockEdit', this.stockQuantityModel).then(response => {
                // this.$emit('snackbarShow', { text: response.response.text,
                //     color: response.ok ? 'success' : 'error',
                //     show: true })
                if (response.ok) {
                    let index = this.catalog.findIndex(item => item.id === response.response.data.offerId)
                    this.catalog[index].stockQuantity = response.response.data.stockQuantity
                }
            })
        },
      saveProduct() {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('products/productCreate', this.productModel).then(response => {
            if (response.ok) {
              this.paramsSnackbar.color = 'success'
              this.paramsSnackbar.text = 'Успешно сохранено!'
              if (this.productModel.id) {
                let index = this.catalog.findIndex(item => item.id === this.productModel.id)
                this.$set(this.catalog, index, response.data)

              } else {
                this.productModel.id = response.data.id
                this.$set(this.catalog, this.catalog.length, response.data)
              }
            }
            this.paramsSnackbar.show = true
          })
        }
      },
      createProduct() {
        this.productModel = Object.assign({}, this.productModelDef)
        this.dialog = true
      },
      updateProduct(item) {
        this.productModel = Object.assign({}, this.catalog.find(product => product.id === +item.id))
        this.dialog = true
      },
      async deleteItem(deliveryId) {
        this.$refs.confirm.open('Удаление товара/услуги', 'Вы действительно хотите удалить?',
            { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
            .then((confirm) => {
              if (confirm === true) {
                this.$store.dispatch('products/productDelete', deliveryId).then(response => {
                  this.paramsSnackbar.color = 'error'
                  if (response.ok) {
                    this.paramsSnackbar.color = 'success'
                    const index = this.catalog.findIndex(item => item.id === response.data.id)
                    this.catalog.products.splice(index, 1)
                  }
                  this.paramsSnackbar.text = response.response.text
                  this.paramsSnackbar.show = true
                })
              }
            })
      }
    },
  created() {
    this.$store.dispatch('cards/deliveriesAll', this.$route.params['pathMatch'])
    this.$store.dispatch('products/productCategoriesAll', this.$route.params['pathMatch'])
    this.$store.dispatch('products/changeBotIdModelDefault', this.$route.params['pathMatch'])
  }
}
</script>

<style scoped>

</style>
